import Armature from '../Armature';

export default class PlusThreeEffect extends Armature {
    public create(params: any): void {
        super.create({
            ...params,
            name: 'plusThreeEffect',
            dragonbonesName: 'CardsVFX',
            armatureName: '+3Cards_Overlay',
            animationName: 'animation',
        });
    }
}
